export default __webpack_public_path__ + "static/media/speaker1.77de45b5.jpeg";